module.exports = __webpack_public_path__ + "media/icons/information-af721070.png";